import { get, post, put, _delete } from './Tools';

const getAll = async () => {
    const response = await get(`${process.env.REACT_APP_SERVER}odoo_attendance/get/all`);
    return response;
};

const getById = async (id) => {
    const response = await get(`${process.env.REACT_APP_SERVER}odoo_attendance/${id}`);
    return response;
};

const getByEmployeeAndPeriod = async (empleadoId, fechaInicial, fechaFinal) => {
    const response = await get(
        `${process.env.REACT_APP_SERVER}odoo_attendance/by-employee-period/${empleadoId}?fecha_inicial=${fechaInicial}&fecha_final=${fechaFinal}`
    );
    return response;
};

const createOrUpdate = async (data) => {
    const response = await post(`${process.env.REACT_APP_SERVER}odoo_attendance`, data);
    return response;
}

const update = async (id, data) => {
    const response = await put(`${process.env.REACT_APP_SERVER}odoo_attendance/${id}`, data);
    return response;
}

const deleteById = async (id) => {
    const response = await _delete(`${process.env.REACT_APP_SERVER}odoo_attendance/${id}`);
    return response;
}

const updateCheckInOut = async (data) => {
    const response = await put(`${process.env.REACT_APP_SERVER}odoo_attendance/update-checkinout`, data);
    return response;
}

const createOrUpdateCheckInOut = async (data) => {
    const response = await put(`${process.env.REACT_APP_SERVER}odoo_attendance/create-or-update-checkinout`, data);
    return response;
}

const generateMassiveAttendances = async (data) => {
  const response = await post(`${process.env.REACT_APP_SERVER}odoo_attendance/generate-massive-attendances`, data);
  return response;
};

const deleteMassiveAttendances = async (data) => {
  const response = await post(`${process.env.REACT_APP_SERVER}odoo_attendance/delete-massive-attendances`, data);
  return response;
};

const recalcularPorEmpleado = async (empleado_id, fecha_inicial, fecha_final) => {
    const response = await post(
        `${process.env.REACT_APP_SERVER}odoo_attendance/recalcular-por-empleado`,
        { empleado_id, fecha_inicial, fecha_final }
    );
    return response;
}

export { getAll, getById, getByEmployeeAndPeriod, createOrUpdate, update, deleteById, updateCheckInOut, createOrUpdateCheckInOut, generateMassiveAttendances, deleteMassiveAttendances, recalcularPorEmpleado };